const { over, transform } = require("lodash");

define([
  'react',
  'prop-types',
  'react-transition-group',
  'underscore',
  'es6!launcher/util/listbuilder/constants',
], (React, PropTypes, ReactTransitionGroup, _, Constants) => {
  const { CSSTransitionGroup } = ReactTransitionGroup;
  const { FormTypes, FormGoals, SUMO_BADGE_PLACEMENT_VAL, SUMO_BADGE_HEIGHT_VAL } = Constants;

  const MAX_SIZES = {
    small: 400,
    medium: 512,
    large: 640,
    xlarge: 720,
    sumo: 8192,
  };

  return Component => {
    // Calculates the scale of the popup by getting the size of the popup container
    // and scaling to match popup size.
    class PopupScale extends React.Component {
      static propTypes = {
        size: PropTypes.string,
        fullscreen: PropTypes.bool,
        container: PropTypes.object,
        noSumoBranding: PropTypes.bool.isRequired,
      };

      static defaultProps = {
        size: 'medium',
      };

      constructor(props) {
        super(props);

        this.state = {
          popupContainerWidth: 0,
          popupContainerHeight: 0,
          secondsElapsed: 0, // TEMPORAL CODE
        };
        this.timer = null; // TEMPORAL CODE
        this.isSocialProof = this.props.formType === FormTypes.POPUP && this.props.goal === FormGoals.SOCIAL_PROOF;

        this.saveContainer = this.saveContainer.bind(this);
        this.onResizeWindow = this.onResizeWindow.bind(this);
      }

      componentDidMount() {
        const { onChangeSize, width, height, formType } = this.props;

        if (formType === FormTypes.INLINE_POPUP && onChangeSize) {
          const adjustedHeight = this.getRatio(width, height) * height;
          onChangeSize(adjustedHeight);
        }

        window.addEventListener('resize', this.onResizeWindow, true);

        // TEMPORAL CODE
        this.timer = setInterval(() => {
          this.setState((prevState) => ({
            secondsElapsed: prevState.secondsElapsed + 1,
          }));
        }, 1000);
      }

      componentWillUnmount() {
        window.removeEventListener('resize', this.onResizeWindow, true);

        // TEMPORAL CODE
        if (this.timer) {
          clearInterval(this.timer);
        }
      }

      componentWillUpdate() {
        this.updateContainerDimensions();
      }

      componentDidUpdate() {
        this.updateContainerDimensions();
      }

      onResizeWindow() {
        // Rerender so we recalculate the size.
        this.forceUpdate();
      }

      saveContainer(container) {
        this.container = container;
        this.updateContainerDimensions();
      }

      updateContainerDimensions() {
        if (!this.container) return;
        const { popupContainerWidth, popupContainerHeight } = this.state;
        const newWidth = this.container.clientWidth;
        const newHeight = this.container.clientHeight;

        if (popupContainerWidth !== newWidth || popupContainerHeight !== newHeight) {
          this.setState({ popupContainerWidth: newWidth, popupContainerHeight: newHeight }, function() {
            // Rerender when state has successfully stored new dimensions
            this.forceUpdate();
          });
        }
      }

      getContainerDimensions() {
        const { fullscreen, container, formType } = this.props;
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1; //&& ua.indexOf("mobile");

        if (!fullscreen || formType === FormTypes.INLINE_POPUP) {
          if (!container) return { containerWidth: 0, containerHeight: 0 };

          return {
            containerWidth: container.clientWidth,
            containerHeight: container.clientHeight,
          }
        }

        // If fullscreen, get window dimensions.
        if (isAndroid) {
          return { containerWidth: screen.availWidth, containerHeight: screen.availHeight };
        } else {
          return {
            containerWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            containerHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
          }
        }
      }

      getRatio(popupWidth, popupHeight) {
        const { size, isPreview, formType, goal, noSumoBranding } = this.props;

        let { containerWidth, containerHeight } = this.getContainerDimensions();
        const displayAsFormType = isPreview ? FormTypes.POPUP : formType;
        let PERCENT_OF_WINDOW = (formType === FormTypes.SCROLL_BOX && !isPreview) ? 1 : 0.98;

        // Don't scale if needed variables don't exist.
        if (!containerWidth || !containerHeight || !popupWidth || !popupHeight) return 1;

        // Adjust size to compensate for ruler
        if (isPreview && containerWidth && containerHeight) {
          containerWidth -= 25;
          containerHeight -= 25;
        }

        // Calculate max width, height. Default to medium size if size doesn't exist.
        let maxHeight = Math.round(Math.min(MAX_SIZES[size || 'medium'], containerHeight * PERCENT_OF_WINDOW));
        let maxWidth = Math.round(Math.min(MAX_SIZES[size || 'medium'], containerWidth * PERCENT_OF_WINDOW));

        // Calculate badge height % for window edge buffer to allow for sumo badge display
        // Sumo badge css height is set to 32px; add 10px for buffer
        const sumoBadgeBuffer = SUMO_BADGE_HEIGHT_VAL + SUMO_BADGE_PLACEMENT_VAL + 10;
        const sumoBadgePercent = containerHeight ? (sumoBadgeBuffer / containerHeight) : 0;

        // Adjust window ratio to allow space for sumo badge for non-pro popup users on small screens
        if (
          formType === FormTypes.POPUP && !noSumoBranding
          && containerHeight < (popupHeight + sumoBadgeBuffer) * Math.min(maxWidth / popupWidth, maxHeight / popupHeight)
        ) {
          PERCENT_OF_WINDOW -= sumoBadgePercent;
          maxWidth = Math.round(Math.min(MAX_SIZES[size || 'medium'], containerWidth * PERCENT_OF_WINDOW));
          maxHeight = Math.round(Math.min(MAX_SIZES[size || 'medium'], containerHeight * PERCENT_OF_WINDOW));
        }

        // Prevent sumo size when selected in different popup style
        if (size =='sumo' && formType === FormTypes.SCROLL_BOX) {
          maxWidth = Math.round(Math.min(MAX_SIZES['xlarge'], containerWidth * PERCENT_OF_WINDOW));
          maxHeight = Math.round(Math.min(MAX_SIZES['xlarge'], containerHeight * PERCENT_OF_WINDOW));
        }

        if (formType === FormTypes.WELCOME_MAT) {
          maxWidth = containerWidth;
          maxHeight = containerHeight;

          // Adjust margins for preview mode
          if (isPreview) {
            maxWidth = containerWidth - 25;
            maxHeight = containerHeight - 25;
          }
        } else if (displayAsFormType === FormTypes.SCROLL_BOX) {
          // Readjust max width if window is greater than 1366 and form type is scroll box
          maxWidth = (maxWidth / Math.min(1366, containerWidth)) * containerWidth;
        }

        let ratio;

        if (displayAsFormType === FormTypes.INLINE_POPUP) {
          ratio = (maxWidth / popupWidth);
        } else {
          ratio = Math.min(maxWidth / popupWidth, maxHeight / popupHeight);
        }

        // Adjust the size of the Social Proof Form
        if (this.isSocialProof) {
          ratio = 1;
        }

        return ratio;
      }

      getAdjustedHeight(ratio, popupHeight) {
        return Math.min(popupHeight * ratio, popupHeight);
      }

      renderPopup(ratio, hasSocialButton) {
        const {
          height,
          width,
          formType,
          isPreview,
          scrollBoxPosition,
          showPosition,
          size,
          goal,
          advancedForm,
          popupDisplayTime,
        } = this.props;

        const isAdvancedForm = (goal === 'custom' && advancedForm);
        if (isAdvancedForm) return <Component {...this.props} scaleRatio={1} />;

        let scaleStyle;

        if(formType === FormTypes.INLINE_POPUP && !isPreview) {
          const adjustedHeight = this.getAdjustedHeight(ratio, height);
          scaleStyle = {
            position: 'relative',
            transform: `translate(-50%,-50%) scale(${ratio})`,
            transformOrigin: 'top center',
            MozTransformOrigin: 'top center',
            top: adjustedHeight / 2,
            left: '50%',
            height: adjustedHeight,
            width: width,
          };
        } else if (formType === FormTypes.SCROLL_BOX  && isPreview) {
          scaleStyle = {
            position: 'absolute',
            transform: `scale(${ratio})`,
          };

          if (scrollBoxPosition) {
            const boxPosition = scrollBoxPosition.replace('-', ' ');
            scaleStyle.transformOrigin = boxPosition;
            scaleStyle.MozTransformOrigin = boxPosition;
            if (boxPosition.indexOf('top') > -1) {
              scaleStyle.top = '5px';
              scaleStyle.marginTop = (ratio) > 1 ? `${41 - (ratio * 4)}px` : '41px';
            }

            if (boxPosition.indexOf('left') > -1) {
              scaleStyle.marginLeft = (ratio) > 1 ? `${25 - (ratio * 4)}px` : '21px';
            }

            scaleStyle.bottom = boxPosition.indexOf('bottom') > -1 ? '0px' : '';
            scaleStyle.right = boxPosition.indexOf('right') > -1 ? '0px' : '';
          }
        } else if (formType === FormTypes.WELCOME_MAT && isPreview) {
          scaleStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: `translate(-50%,-50%) scale(${ratio}) translateZ(0)`,
            overflow: 'hidden',
            marginTop: 22,
            marginLeft: 10,
          };
        } else {
          scaleStyle = {
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: `translate(-50%,-50%) scale(${ratio}) translateZ(0)`,
            overflow: formType === FormTypes.WELCOME_MAT ? 'hidden' : 'visible',
          };
        }

        if (hasSocialButton && !isPreview) {
          scaleStyle.transform = `translate(-50%, -50%) scale(${ratio})`;
          delete scaleStyle.zoom;
        }

        const validMarginFormTypes = [
          FormTypes.POPUP,
          FormTypes.INLINE_POPUP,
          FormTypes.CLICK_TRIGGER_POPUP,
          FormTypes.GAME,
        ];

        if ((validMarginFormTypes.indexOf(formType) > -1) && isPreview) {
          if (size === 'sumo') {
            scaleStyle.marginTop = `${(20 / ratio)}px`;
            scaleStyle.marginLeft = `${(10 / ratio)}px`;
          } else {
            scaleStyle.marginTop = `${20 / Math.max(1, ratio)}px`;
            scaleStyle.marginLeft = `${10 / Math.max(1, ratio)}px`;
          }
        }

        if (this.isSocialProof) {
          let slideDirection = this.props.slideDirection;
          const [vertical, horizontal] = showPosition.split('-');

          let scaleStyle = {
            position: 'fixed',
            transform: `scale(${ratio})`,
            overflow: 'visible',
            transformOrigin: `${vertical} ${horizontal}`,
            [vertical]: 10,
            [horizontal]: 10,
            whiteSpace: 'nowrap',
            // attempt to keep on top, but if they use a higher zIndex on the client page, this will not work
            // some clients uses zIndex to handle background movements, at least with zIndex 2 can hide the SP Form
            zIndex: 999999,
          };

          if (showPosition.indexOf('top') !== -1 && slideDirection === 'up') slideDirection = 'down';
          else if (showPosition.indexOf('right') !== -1 && slideDirection === 'in') slideDirection = 'left';
          else if (showPosition.indexOf('left') !== -1 && slideDirection === 'in') slideDirection = 'right';

          const maxSeconds = popupDisplayTime || 0;
          const remainingSeconds = maxSeconds - (this.state.secondsElapsed + 1);
          const percentage = (remainingSeconds / maxSeconds) * 100;

          return (
            <div
              className="listbuilder-popup-scale"
              style={scaleStyle}
            >
             <CSSTransitionGroup
                transitionName={`sumome-popup-transition-${slideDirection}`}
                transitionAppear={true}
                transitionAppearTimeout={0}
                transitionEnter={false}
                transitionLeave={true}
              >
                <div ref={this.saveContainer}>
                  <Component
                    {...this.props}
                    scaleRatio={ratio}
                  />
                  {/* 4. Display the timer for testing purposes */}
                  <div style={{
                    position: 'absolute',
                    bottom: -3,
                    left: 40,
                    width: '80%',
                    height: '2px',
                    borderRadius: '8px',
                    overflow: 'hidden',
                    marginTop: '20px',
                  }}>
                    <div
                      style={{
                        width: `${percentage}%`,
                        height: '100%',
                        backgroundColor: '#76c7c0',
                        transition: 'width 1s linear',
                      }}
                    />
                  </div>
                </div>
              </CSSTransitionGroup>
            </div>
          );
        }

        return (
          <div
            className="listbuilder-popup-scale"
            style={scaleStyle}
          >
            <div ref={this.saveContainer}>
              <Component
                {...this.props}
                scaleRatio={ratio}
              />
          </div>
        </div>
        );
      }

      renderScrollBox(ratio, hasSocialButton) {
        const {
          showPosition,
          currentStep,
          size,
          goal,
          advancedForm,
        } = this.props;

        const isAdvancedForm = (goal === 'custom' && advancedForm);
        let slideDirection = this.props.slideDirection;

        if (showPosition.indexOf('top') !== -1 && slideDirection === 'up') slideDirection = 'down';
        else if (showPosition.indexOf('right') !== -1 && slideDirection === 'in') slideDirection = 'left';
        else if (showPosition.indexOf('left') !== -1 && slideDirection === 'in') slideDirection = 'right';

        let scaleStyle = {};
        if (hasSocialButton) {
          scaleStyle = {
            transform: `scale(${ratio})`,
          };
        } else {
          scaleStyle = {
            transform: `scale(${ratio})`,
          };
        }

        let component = (
          <div ref={this.saveContainer}>
            <Component
              {...this.props}
              scaleRatio={ratio}
            />
          </div>
        );

        if (currentStep !== 'success') {
          component = (
            <CSSTransitionGroup
              transitionName={`sumome-scrollbox-transition-${slideDirection}`}
              transitionAppear={true}
              transitionAppearTimeout={0}
              transitionEnter={false}
              transitionLeave={false}
            >
              {component}
            </CSSTransitionGroup>
          );
        }

        let scaleClass = `scrollbox-popup-scale scrollbox-${showPosition}`;

        if (isAdvancedForm) {
          scaleClass += ` sumome-scrollbox-${size}`;
        }

        return (
          <div
            className={scaleClass}
            style={scaleStyle}
          >
           {component}
          </div>
        );
      }

      renderSmartBar() {
        return (
          <Component
            {...this.props}
            scaleRatio={1}
          />
        );
      }

      renderWelcomeMat() {
        return (
          <div className='sumome-react-wysiwyg-grid'>
            <Component
              {...this.props}
              scaleRatio={1}
            />
          </div>
        );
      }

      render() {
        const {
          width,
          height,
          isPreview,
          advancedForm,
          goal,
          components,
        } = this.props;
        const ratio = (goal === 'custom' && advancedForm) ? 1 : this.getRatio(width, height);
        let formType = this.props.formType;
        const hasSocialButton = _.filter(components.toJS(), component => component.type === 'socialButton').length > 0;

        if (isPreview && formType !== FormTypes.SMART_BAR) {
          formType = FormTypes.POPUP;
        }

        switch(formType) {
          case Constants.FormTypes.SCROLL_BOX:
            return this.renderScrollBox(ratio, hasSocialButton);
          case Constants.FormTypes.SMART_BAR:
            return this.renderSmartBar();
          case Constants.FormTypes.WELCOME_MAT:
            return this.renderWelcomeMat();
          default:
            return this.renderPopup(ratio, hasSocialButton);
        }
      }
    }

    return PopupScale;
  };
});
